export const defaultValidationRule = {
  validateOnBlur: true,
  validateOnChange: false,
  validateOnModelUpdate: false,
};
